import React from 'react';
import Tippy from '@tippyjs/react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';
import {followCursor} from 'tippy.js';

const TooltipStyled = styled(Tippy)`
	&.tippy-box&[data-theme~='light-border'] {
		background-color: #ebebeb;
		border-color: #e6e6e6;
		font-size: 11px;
		color: #535353;
		font-weight: 500;
		box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.05);

		&[data-placement^='bottom'] > .tippy-arrow:before {
			border-bottom-color: #ebebeb;
		}
		&[data-placement^='bottom'] > .tippy-arrow:after {
			border-bottom-color: #e6e6e6;
		}
		&[data-placement^='top'] > .tippy-arrow:before {
			border-top-color: #ebebeb;
		}
		&[data-placement^='top'] > .tippy-arrow:after {
			border-top-color: #e6e6e6;
		}
		&[data-placement^='right'] > .tippy-arrow:before {
			border-right-color: #ebebeb;
		}
		&[data-placement^='right'] > .tippy-arrow:after {
			border-right-color: #e6e6e6;
		}
		&[data-placement^='left'] > .tippy-arrow:before {
			border-left-color: #ebebeb;
		}
		&[data-placement^='left'] > .tippy-arrow:after {
			border-left-color: #e6e6e6;
		}
	}
	.bold-font-weight {
		font-weight: bold;
	}
`;

export const Tooltip = ({children, spanStyle, ...props}) => {
	return (
		<TooltipStyled
			{...props}
			content={props.content && <span>{props.content}</span>}
			maxWidth={props.maxWidth || 250}
			placement={props.placement}
			delay={props.delay}
			disabled={!props.content || props.disabled}
			theme="light-border"
			plugins={[followCursor]}
		>
			<span style={spanStyle}>{children}</span>
		</TooltipStyled>
	);
};

Tooltip.propTypes = {
	children: PropTypes.any,
	content: PropTypes.any,
	delay: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
	placement: PropTypes.string,
	disabled: PropTypes.bool,
	maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	spanStyle: PropTypes.object,
	props: PropTypes.arrayOf(PropTypes.any), // See https://atomiks.github.io/tippyjs/v6/all-props for valid Tippy props
};

Tooltip.defaultProps = {
	content: 'Place tooltip text here!',
	delay: [500, 200],
	placement: 'bottom',
	spanStyle: {width: '100%', display: 'flex'},
};
